var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37872 7.64877L3.81979 1.82377C3.76622 1.75413 3.68229 1.71484 3.59479 1.71484H2.21444C2.09479 1.71484 2.02872 1.85234 2.10194 1.9452L6.84122 8.00056L2.10194 14.0559C2.08545 14.077 2.07522 14.1022 2.07241 14.1288C2.06961 14.1554 2.07435 14.1823 2.08608 14.2063C2.09782 14.2303 2.11608 14.2506 2.13878 14.2647C2.16147 14.2789 2.18769 14.2863 2.21444 14.2863H3.59479C3.68229 14.2863 3.76622 14.2452 3.81979 14.1773L8.37872 8.35413C8.54122 8.1452 8.54122 7.85592 8.37872 7.64877ZM13.8073 7.64877L9.24837 1.82377C9.19479 1.75413 9.11086 1.71484 9.02336 1.71484H7.64301C7.52336 1.71484 7.45729 1.85234 7.53051 1.9452L12.2698 8.00056L7.53051 14.0559C7.51402 14.077 7.50379 14.1022 7.50099 14.1288C7.49818 14.1554 7.50292 14.1823 7.51466 14.2063C7.52639 14.2303 7.54465 14.2506 7.56735 14.2647C7.59005 14.2789 7.61627 14.2863 7.64301 14.2863H9.02336C9.11086 14.2863 9.19479 14.2452 9.24837 14.1773L13.8073 8.35413C13.9698 8.1452 13.9698 7.85592 13.8073 7.64877Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleRight);
export default __webpack_public_path__ + "static/media/double-right.ac9d4d4f475dae47db96619c483fbe00.svg";
export { ForwardRef as ReactComponent };